(() => {
    window.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll(".form--inlinevalidation input[type='text'], .form--inlinevalidation textarea.form-control, .form--inlinevalidation input[type='email'], .form--inlinevalidation input[type='number'], .form--inlinevalidation input[type='tel'], .form--inlinevalidation input[type='radio'], .form--inlinevalidation input[type='search'], .form--inlinevalidation input[type='password'], .form--inlinevalidation select").forEach((input) => {
            ['blur','keydown'].forEach( evt => {
                input.addEventListener(evt, () => {
                    if (!input.hasAttribute('required')
                        && !input.hasAttribute('pattern')
                        && input.value === ''
                    ) {
                        return
                    }

                    input.classList.add('touched')
                })
            })
        })
    })
}) ()
